import moment from "moment";
import axios from "axios";
import _ from "lodash";
import { getTokenHeader } from "@/helpers/commonHelper";
import POIDestinationStateFields from "@/components/POI/POIStateFields/POIDestinationStateFields/POIDestinationStateFields.vue";
import POISkiStateFields from "@/components/POI/POIStateFields/POISkiStateFields/POISkiStateFields.vue";
import POILiftStateFields from "@/components/POI/POIStateFields/POILiftStateFields/POILiftStateFields.vue";
import POILakeStateFields from "@/components/POI/POIStateFields/POILakeStateFields/POILakeStateFields.vue";
import POIParkingLotStateFields from "@/components/POI/POIStateFields/POIParkingLotStateFields/POIParkingLotStateFields.vue";
import POITrackStateFields from "@/components/POI/POIStateFields/POITrackStateFields/POITrackStateFields.vue";
import POITrailStateFields from "@/components/POI/POIStateFields/POITrailStateFields/POITrailStateFields.vue";
import POISledgeTrackStateFields from "@/components/POI/POIStateFields/POISledgeTrackStateFields/POISledgeTrackStateFields.vue";
import POIHikingStateFields from "@/components/POI/POIStateFields/POIHikingStateFields/POIHikingStateFields.vue";
import POIHutsStateFields from "@/components/POI/POIStateFields/POIHutsStateFields/POIHutsStateFields.vue";
import POIEditDialog from "@/components/POI/POIEditDialog/POIEditDialog.vue";
import POIStateLegend from "@/components/POI/POIStateLegend/POIStateLegend.vue";
import POIRegionEditFilter from "@/components/POI/POIRegionEditFilter/POIRegionEditFilter.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { defaultPoi } from "@/helpers/poiHelper";
import { uploadFile } from "@/helpers/fileHelper";
import "./POIRegionEdit.scss";
import RegionStatusBar from "@/components/POI/RegionStatusBar/RegionStatusBar.vue";
import { imports } from "@/helpers/poiHelper";
import Vue from "vue";
import { stateItems } from "@/configuration/formConfigurations";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
const state = [
  { id: "", title: "Keine Angabe" },
  { id: "open", title: "Geöffnet" },
  { id: "closed", title: "Geschlossen" },
  { id: "openingHours", title: "Gemäß Öffnungszeiten" }
];

export default {
  name: "POIRegionEdit",
  data: () => ({
    editedItem: {},
    editedIndex: -1,
    dialog: false,
    step: 1,
    expanded: [],
    filter: {},
    searchInput: "",
    debouncedSearchText: "",
    uiFilter: {
      categories: [],
      regions: [],
      seasonFeature: ""
    },
    isValid: false,
    seasonFilter: "",
    allPois: [],
    loading: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    headers: {
      mobile: [
        { text: "Titel", value: "title" },
        { text: "Status", value: "state", sortable: false },
        { text: "Aktionen", value: "actions", sortable: false },
        { text: "", value: "data-table-expand" }
      ],
      desktop: [
        { text: "Titel", value: "title" },
        { text: "Zuletzt geändert", value: "updatedAt" },
        { text: "Zuletzt importiert", value: "updatedByImport" },
        { text: "Kategorie", value: "category" },
        { text: "Status", value: "state", sortable: false },
        { text: "Aktionen", value: "actions", sortable: false },
        { text: "", value: "data-table-expand" }
      ]
    },
    defaultMobileBreakpoint: 600,
    windowWidth: window.innerWidth,
    sharedState: Vue.observable({
      stateItems
    })
  }),
  provide() {
    return {
      sharedState: this.sharedState
    };
  },
  async mounted() {
    this.loading = true;
    if (!this.currentUser) await this.$store.dispatch("getCurrentUser");

    await Promise.all([
      this.fetchData(),
      this.loadRegions(),
      this.$store.dispatch("getCategoryGroups", true),
      this.$store.dispatch("getCategoryTypes", true),
      this.$store.dispatch("getGlobalFeatureGroups")
    ]);
    this.allPois = this.$store.state.regionPois;
    this.loading = false;
    window.addEventListener("resize", this.onResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    poiCount() {
      return this.filteredPois?.length || 0;
    },
    isMobile() {
      return this.windowWidth < this.defaultMobileBreakpoint;
    },
    cHeaders() {
      if (this.isMobile) {
        return this.headers.mobile;
      }
      return this.headers.desktop;
    },
    principal() {
      return this.$store.state.selectedPrincipal;
    },
    principals() {
      return this.$store.state.principals;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    userRegions() {
      return this.currentUser?.regions ?? [];
    },
    categoryGroups() {
      return this.$store.state.categoryGroups;
    },
    categoryTypes() {
      return this.$store.state.categoryTypes;
    },
    categoryGroupsForPoi() {
      return this.categoryGroups.filter(
        cg =>
          cg.categoryType === this.editedItem?.categoryType &&
          cg?.categories.length &&
          cg.principals?.includes(this.editedItem?.principal) &&
          !cg.services?.length
      );
    },
    categories() {
      const availableCategories = _.uniq(
        this.allPois
          .map(poi => poi.category)
          .concat(_.flatten(this.allPois.map(poi => poi.additionalCategories)))
      );
      return _.flatten(
        this.$store.state.categoryGroups?.map(cg => cg.categories)
      ).filter(cat => availableCategories.includes(cat._id));
    },
    pois() {
      return _.uniqBy(this.$store.state.regionPois, "_id");
    },
    filteredPois() {
      const searchText = (this.debouncedSearchText || "").toLowerCase();
      if (!searchText.length) return this.pois;
      return this.pois.filter(poi =>
        (poi?.title || "").toLowerCase().includes(searchText)
      );
    },
    features() {
      return _.flatten(
        this.$store.state.globalFeatureGroups?.map(fg => fg.features)
      );
    },
    summerFeature() {
      return this.features.find(f => f.title === "Sommer");
    },
    winterFeature() {
      return this.features.find(f => f.title === "Winter");
    },
    allRegions() {
      return this.$store.state.regions;
    },
    regions() {
      const userRegions = this.currentUser?.regions;
      return (
        userRegions?.map(region =>
          this.allRegions?.find(r => r._id === region)
        ) ?? []
      );
    },
    activeImports() {
      return imports.filter(_ => _.isActive(this.principal)).map(_ => _.typeId);
    }
  },
  components: {
    POIDestinationStateFields,
    POISkiStateFields,
    POILiftStateFields,
    POILakeStateFields,
    POIParkingLotStateFields,
    POITrackStateFields,
    POITrailStateFields,
    POISledgeTrackStateFields,
    POIHikingStateFields,
    POIHutsStateFields,
    POIEditDialog,
    POIStateLegend,
    RegionStatusBar,
    POIRegionEditFilter
  },
  methods: {
    normalizeFilterValue(value) {
      return {
        categories: value?.categories ?? [],
        regions: value?.regions ?? [],
        seasonFeature: value?.seasonFeature ?? ""
      };
    },
    async applyFilter(value) {
      const nextFilter = this.normalizeFilterValue(value);
      this.uiFilter = { ...nextFilter };
      this.filter = {
        ...this.filter,
        categories: [...nextFilter.categories],
        regions: [...nextFilter.regions]
      };
      this.seasonFilter = nextFilter.seasonFeature;
      await this.fetchData();
    },
    async resetFilter() {
      const clearedFilter = this.normalizeFilterValue();
      this.uiFilter = { ...clearedFilter };
      this.filter = {
        ...this.filter,
        categories: [],
        regions: []
      };
      this.seasonFilter = "";
      await this.fetchData();
    },
    nextPage() {
      if (this.page < this.pageCount) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    getCategoryById(category) {
      const cat = this.categories.find(cat => cat._id === category);
      if (cat?.title) return cat.title;
      else return "---";
    },

    checkStep(step, poi) {
      const group = this.categoryGroups.find(
        cg => cg._id === poi?.categoryGroup
      );

      const type = this.categoryTypes.find(
        ct => !!ct?.categories?.find(cat => cat._id === poi.category)
      );
      return group?.poiSteps?.includes(step) || type?.poiSteps?.includes(step);
    },
    formatDate(date) {
      if (date) return moment(date).format("DD.MM.YYYY:HH:mm");
    },
    getStateIcon(poi) {
      let isParkingLot = false;
      if (this.checkStep("parkingLot", poi)) isParkingLot = true;
      switch (poi.state.state) {
        case "open":
          if (isParkingLot) return "mdi-parking";
          else return "mdi-checkbox-blank-circle";
        case "seasonEnd":
          return "mdi-calendar-remove";
        case "closed":
          if (isParkingLot) return "mdi-parking";
          else return "mdi-minus-circle";
        case "openingHours":
          return "mdi-checkbox-blank-circle-outline";
        case "partiallyOpen":
          return "mdi-circle-half-full";
        case "avalancheLock":
          return "mdi-triangle";
        case "capacityExhausted":
        case "highWorkload":
          return "mdi-parking";
        default:
          return "mdi-checkbox-blank-circle-outline";
      }
    },
    getStateColor(poi) {
      let isParkingLot = false;
      if (this.checkStep("parkingLot", poi)) isParkingLot = true;

      switch (poi.state.state) {
        case "open":
          return this.$mainPeacock;
        case "closed":
          if (isParkingLot) return this.$mainRed;
          else return this.$mainRed;
        case "capacityExhausted":
          return this.$mainRed;
        case "openingHours":
          return this.$mainLightBlue;
        case "partiallyOpen":
          return this.$mainYellow;
        case "avalancheLock":
        case "highWorkload":
          return this.$mainYellow;
        case "seasonEnd":
        case "":
        case undefined:
          return this.$mainBlue;
        default:
          return this.$mainPeacock;
      }
    },
    getStateItems(poi) {
      let returnState = [...state];

      if (this.checkStep("hiking", poi))
        returnState = [
          ...state,
          { id: "partiallyOpen", title: "Teilweise begehbar" },
          { id: "avalancheLock", title: "Lawinensperrung" }
        ];
      else if (
        this.checkStep("sledgeTrack", poi) ||
        this.checkStep("track", poi)
      )
        returnState = [
          ...state,
          { id: "avalancheLock", title: "Lawinensperrung" }
        ];
      else if (this.checkStep("ski", poi))
        returnState = [...state, { id: "seasonEnd", title: "Ende der Saison" }];
      else if (this.checkStep("trail", poi))
        returnState = [
          ...state,
          { id: "partiallyOpen", title: "Teilweise geöffnet" }
        ];
      else if (this.checkStep("parkingLot", poi))
        returnState = [
          ...state,
          { id: "highWorkload", title: "Aktuell hohe Auslastung" },
          { id: "capacityExhausted", title: "Belegt/Kapazität erschöpft" }
        ];

      return returnState;
    },
    async loadRegions() {
      if (!this.userRegions.length) return;
      await this.$store.dispatch("getRegions", {
        "_id[$in]": this.userRegions,
        statusBar: true
      });
    },
    async fetchData() {
      try {
        await this.$store.dispatch("getPoisByRegion", {
          seasonFeature: this.seasonFilter ?? "",
          ...this.filter,
          listmode: true
        });
        this.page = 1;
      } catch (error) {
        await this.$store.dispatch("createError", {
          text: "Fehler beim Laden der POIs",
          error
        });
      }
    },
    async save(close, poi) {
      if (poi?.permissions === "read") return;
      try {
        if (poi.logo && typeof poi.logo !== "string") {
          const res = await uploadFile(
            poi.logo,
            poi.id || poi._id,
            "pois",
            poi.principal
          );
          poi.logo = res.url;
        }

        const headers = getTokenHeader();
        await axios.put(
          `${env.poi_api_client_url}poi/${poi.id || poi._id}`,
          poi,
          { headers }
        );
        await this.fetchData();
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert");
        if (close) this.closeAction();
      } catch (error) {
        await this.$store.dispatch("createError", {
          text: "Fehler beim Speichern des POIs",
          error
        });
      }
    },
    debounceSave: _.debounce(async function(close, poi) {
      await this.save(close, poi);
    }, 500),
    changeStep(value) {
      if (
        (this.$refs.editDialog?.$refs?.form.validate() && this.isValid) ||
        value === 2 ||
        value === 1
      )
        this.step = value;
    },

    async close() {
      const res = await this.$confirm(
        "Wollen Sie wirklich Abbrechen? Alle Änderungen werden verworfen!",
        confirmWarningConfig
      );
      if (res) await this.closeAction();
    },
    async closeAction() {
      await this.fetchData();
      this.dialog = false;
      this.isValid = true;
      this.$nextTick(() => {
        this.$refs.editDialog?.$refs?.stepWrapper?.$refs?.media?.clear();
        this.$refs.form?.reset();

        this.step = 1;
        this.editedItem = Object.assign({}, { ...defaultPoi });
        this.editedIndex = -1;
      });
    },

    async editItem(item) {
      this.editedIndex = this.pois.indexOf(item);
      try {
        // list only contains a projection, load full poi so PUT doesn't overwrite fields
        const headers = getTokenHeader();
        const { data } = await axios.get(
          `${env.poi_api_client_url}poi/${item._id}`,
          {
            headers
          }
        );
        this.editedItem = _.merge({}, defaultPoi, data, {
          permissions: item.permissions
        });
        this.dialog = true;
      } catch (error) {
        await this.$store.dispatch("createError", {
          text: "Fehler beim Laden des POIs",
          error
        });
      }
    },
    async patch(poi, fields) {
      if (poi?.permissions === "read") return;
      try {
        const headers = getTokenHeader();
        await axios.patch(
          `${env.poi_api_client_url}poi/${poi.id || poi._id}`,
          fields,
          { headers }
        );
        await this.fetchData();
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert");
      } catch (error) {
        await this.$store.dispatch("createError", {
          text: "Fehler beim Speichern des POIs",
          error
        });
      }
    },
    async saveState(poi) {
      // openingHours is needed to recalculate calculatedOpeningHours in patchPoi
      await this.patch(poi, {
        state: poi.state,
        openingHours: poi.openingHours
      });
    },
    async changeActiveState(poi) {
      if (poi.permissions === "write" || poi.permissions === "admin") {
        const res = await this.$confirm(
          "Wollen Sie diese Änderung wirklich vornehmen?",
          confirmWarningConfig
        );
        if (!res) return;
        poi.active = !poi.active;
        await this.patch(poi, { active: poi.active });
      }
    },
    getRegionTitleById(regionId, poiId) {
      const region = this.allRegions.find(region => region._id === regionId);
      const permissions = region?.pois?.find(poi => poi._id === poiId)
        ?.permissions;
      return `${region?.title} - ${this.mapPermissions(permissions)}`;
    },
    mapPermissions(permissions) {
      switch (permissions) {
        case "read":
          return "Lesen";
        case "write":
          return "Schreiben";
        case "admin":
          return "Admin";
        case "status":
          return "Statusbearbeitung";
        default:
          return "Lesen";
      }
    }
  },
  watch: {
    userRegions: {
      handler: async function(newRegions, oldRegions) {
        // initial load is handled in mounted
        if (!oldRegions?.length || _.isEqual(newRegions, oldRegions)) return;
        this.loading = true;
        await Promise.all([this.loadRegions(), this.fetchData()]);
        this.loading = false;
      },
      deep: true
    },
    searchInput: _.debounce(function(value) {
      const query = (value || "").trim();
      if (!query.length) {
        this.debouncedSearchText = "";
      } else if (query.length >= 3) {
        this.debouncedSearchText = query;
      } else {
        this.debouncedSearchText = "";
      }
      this.page = 1;
    }, 400)
  }
};
